import { Text } from '@actual-app/components/text';

import { color, densidad } from './tokens';

/** Ancho fijo del hueco del emoji en las filas de categoría (B4 · H38). */
export const ANCHO_HUECO_EMOJI = 20;

/**
 * El emoji de la categoría en un hueco de ancho fijo. Sin emoji, un punto
 * tenue en su lugar: así los nombres de todas las filas empiezan a la misma
 * altura (B4 · H38).
 */
export function HuecoEmoji({ emoji }: { emoji: string | null }) {
  return (
    <Text
      aria-hidden
      data-testid={emoji ? 'category-emoji' : 'category-emoji-vacio'}
      style={{
        ...densidad.emoji,
        width: ANCHO_HUECO_EMOJI,
        flexShrink: 0,
        textAlign: 'center',
        ...(!emoji && { color: color.fg4, opacity: 0.6 }),
      }}
    >
      {emoji ?? '·'}
    </Text>
  );
}
